import React from 'react';
import PageShell from '@/components/PageShell';
import SEO from '@/components/SEO';

const LAST_UPDATED = 'July 20, 2026';

const PrivacyPolicy = () => (
  <PageShell trackPage="/privacy-policy">
    <SEO title="Privacy Policy | Amigo's Bail Bonds" description="How Amigo's Bail Bonds collects, uses, and protects your personal information." path="/privacy-policy" />
    <div className="page-hero">
      <div className="eyebrow">LEGAL</div>
      <h1 className="section-title">PRIVACY POLICY</h1>
      <p className="section-subtitle" style={{ margin: '0 auto' }}>Last updated: {LAST_UPDATED}</p>
    </div>
    <section className="section section--void">
      <div className="container prose" style={{ maxWidth: 780 }}>
        <p>
          Amigo&apos;s Bail Bonds (&ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) respects your privacy. This Privacy Policy explains
          how we collect, use, disclose, and safeguard your information when you visit our website or
          submit a bail bond request.
        </p>

        <h2>Information We Collect</h2>
        <ul>
          <li><strong>Information you provide:</strong> name, phone number, defendant details, jail/city, case information, and any notes you submit through our forms.</li>
          <li><strong>Automatically collected information:</strong> device type, browser, approximate location (via IP), pages visited, and referral source.</li>
          <li><strong>Attribution data:</strong> UTM campaign parameters and first-party visitor identifiers used to understand how visitors find our site.</li>
        </ul>

        <h2>How We Use Your Information</h2>
        <ul>
          <li>To respond to your bail bond request and provide the services you asked for.</li>
          <li>To contact you by phone or text message about your request, consistent with the consent you provide.</li>
          <li>To maintain internal case records, audit trails, and staff assignment for quality and compliance purposes.</li>
          <li>To understand website performance and improve our services (aggregated analytics only — never sold).</li>
        </ul>

        <h2>Information Sharing</h2>
        <p>
          We do not sell your personal information. We may share information with courts, sureties, and
          law enforcement as legally required to complete a bail bond transaction, and with service
          providers (such as email delivery providers) strictly to operate our business.
        </p>

        <h2>Data Security</h2>
        <p>
          We use industry-standard safeguards, including encrypted connections (TLS), password hashing,
          role-based access control, and audit logging, to protect your information.
        </p>

        <h2>Your Choices</h2>
        <ul>
          <li>You may reply STOP to any text message to opt out of future texts.</li>
          <li>You may contact us at any time to request access to, correction of, or deletion of your information, subject to legal recordkeeping requirements related to bail bond transactions.</li>
        </ul>

        <h2>Contact Us</h2>
        <p>Questions about this policy? Call us at (936) 828-2500 or use our <a href="/contact">Contact page</a>.</p>
        <p style={{ color: 'var(--text-dim)', fontSize: '0.82rem', marginTop: '2rem' }}>
          Version 1.0 · Created {LAST_UPDATED} · Last Modified {LAST_UPDATED}
        </p>
      </div>
    </section>
  </PageShell>
);

export default PrivacyPolicy;
